module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "m_context plr"
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    ref: "addForm",
    attrs: {
      "id": "addForm",
      "model": _vm.form,
      "rules": _vm.rules,
      "label-width": "12.5%"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('lin_global.certificateName'),
      "prop": "certificateName"
    }
  }, [_c('el-input', {
    attrs: {
      "id": "userName",
      "placeholder": _vm.$t('lin_global.bitian')
    },
    model: {
      value: (_vm.form.certificateName),
      callback: function($$v) {
        _vm.$set(_vm.form, "certificateName", $$v)
      },
      expression: "form.certificateName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('lin_global.guojia'),
      "prop": "country"
    }
  }, [_c('el-input', {
    attrs: {
      "id": "nickName",
      "placeholder": _vm.$t('lin_global.guojiatips')
    },
    model: {
      value: (_vm.form.country),
      callback: function($$v) {
        _vm.$set(_vm.form, "country", $$v)
      },
      expression: "form.country"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('lin_global.shengfen'),
      "prop": "province"
    }
  }, [_c('el-input', {
    attrs: {
      "id": "phoneNum",
      "placeholder": _vm.$t('lin_global.shenfentips')
    },
    model: {
      value: (_vm.form.province),
      callback: function($$v) {
        _vm.$set(_vm.form, "province", $$v)
      },
      expression: "form.province"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('lin_global.city'),
      "prop": "city"
    }
  }, [_c('el-input', {
    attrs: {
      "id": "phoneNum",
      "placeholder": _vm.$t('lin_global.cityTips')
    },
    model: {
      value: (_vm.form.city),
      callback: function($$v) {
        _vm.$set(_vm.form, "city", $$v)
      },
      expression: "form.city"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('lin_global.gongsi'),
      "prop": "company"
    }
  }, [_c('el-input', {
    attrs: {
      "id": "phoneNum",
      "placeholder": _vm.$t('lin_global.gongsiTips')
    },
    model: {
      value: (_vm.form.company),
      callback: function($$v) {
        _vm.$set(_vm.form, "company", $$v)
      },
      expression: "form.company"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('lin_global.youxiang'),
      "prop": "email"
    }
  }, [_c('el-input', {
    attrs: {
      "id": "phoneNum",
      "placeholder": _vm.$t('lin_global.emailTips')
    },
    model: {
      value: (_vm.form.email),
      callback: function($$v) {
        _vm.$set(_vm.form, "email", $$v)
      },
      expression: "form.email"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('lin_global.youxiaoqi'),
      "prop": "termTime"
    }
  }, [_c('el-input', {
    attrs: {
      "id": "phoneNum",
      "placeholder": _vm.$t('lin_global.youxiaoqiTips')
    },
    model: {
      value: (_vm.form.termTime),
      callback: function($$v) {
        _vm.$set(_vm.form, "termTime", $$v)
      },
      expression: "form.termTime"
    }
  }, [_c('template', {
    slot: "append"
  }, [_vm._v(_vm._s(_vm.$t('lin_global.danweitian')))])], 2)], 1), _vm._v(" "), (_vm.showsManufacturerCert) ? _c('el-form-item', {
    attrs: {
      "label": _vm.$t('lin_global.certTypeLabel'),
      "required": ""
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.form.certificateType),
      callback: function($$v) {
        _vm.$set(_vm.form, "certificateType", $$v)
      },
      expression: "form.certificateType"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": '1'
    }
  }, [_vm._v(_vm._s(_vm.$t('lin_global.certForCustomer')))]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": '2'
    }
  }, [_vm._v(_vm._s(_vm.$t('lin_global.certForManufacturer')))])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.form.certificateType == 1) ? _c('el-form-item', {
    attrs: {
      "label": _vm.$t('lin_global.label_areaid'),
      "prop": "distributorId"
    }
  }, [_c('MechanismSelector', {
    attrs: {
      "data": _vm.mechanismData,
      "mselect": true,
      "classs": 'w_33'
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('lin_global.remark')
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('lin_global.xuantian')
    },
    model: {
      value: (_vm.form.certificateDesc),
      callback: function($$v) {
        _vm.$set(_vm.form, "certificateDesc", $$v)
      },
      expression: "form.certificateDesc"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "id": "onCancel"
    },
    on: {
      "click": _vm.onCancel
    }
  }, [_vm._v(_vm._s(_vm.$t('lin_btn.cancel')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.isSubmit
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v(_vm._s(_vm.$t('lin_global.xinjian')))])], 1)], 1)], 1)], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-455d2c19"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/safe/certNew.vue
// module id = 1029
// module chunks = 0